import React, { useState } from 'react';
import {
  Box,
  Typography,
  Divider,
  Grid,
  useTheme,
  makeStyles,
} from '@material-ui/core';
import useAutocomplete from '@material-ui/lab/useAutocomplete';

import KenSelect from '../../global_components/KenSelect/index';
import context from '../../Utils/context';
import KenAutoComplete from '../../global_components/KenAutoComplete/index';
import { useTranslation } from 'react-i18next';
import { getInstituteByTypeAndInstitute } from '../../Utils/apiServices';
import KenLoader from '../../Components/KenLoader/index';

import KenSnackbar from '../../Components/KenSnackbar/index';

const SmsAndMailSelection = ({
  typeValue,
  handleGradeWiseDetails,
  type,
  handleAllOption,
}) => {
  const { t } = useTranslation();

  const [institute, setInstitute] = useState([]);
  const [selectedInstitute, setSelectedInstitute] = useState('All');

  const [campus, setCampus] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [selectedDepartments, setSelectedDepartments] = useState('All');

  const [grades, setGrades] = useState([]);
  const [classIds, setClassIds] = useState([]);
  const [selectedClassIds, setSelectedClassIds] = useState();
  const [loading, setLoading] = React.useState(false);

  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  React.useEffect(() => {
    getInstituteDetails();
  }, []);

  const getInstituteDetails = () => {
    if (typeValue === 'institute') {
      getInstituteList();
    }
  };

  const getInstituteList = async () => {
    try {
      await setLoading(true);
      const institute = await getInstituteByTypeAndInstitute('institute', 0);
      const mapInstitute = institute.map((v) => {
        return { label: v.Name, value: v.Id, ...v };
      });
      if (type === 1) {
        mapInstitute.push({ label: t('labels:All'), value: 'All' });
      }
      await setInstitute(mapInstitute);
      await setLoading(false);
    } catch (error) {
      await setLoading(false);
      handleSnackbarOpen('error', t('messages:no_data_found'));
    }
  };

  const contactType = [
    { title: 'Student', value: 'Student' },
    { title: 'Faculty', value: 'Faculty' },
    { title: 'Parent', value: 'Parent' },
    { title: t('labels:All'), value: 'All' },
  ];

  const getProgramByDeptId = async (id) => {
    try {
      await setGrades([]);
      await setLoading(true);
      const getDepartment = await getInstituteByTypeAndInstitute(
        'progbydept',
        id
      );
      const mapDept = getDepartment.map((v) => {
        return { title: v.Name, value: v.id, ...v };
      });
      if (type === 1) {
        mapDept.push({ title: t('labels:All'), value: 'All', Id: 'All' });
      }
      await setGrades(mapDept);
      await setLoading(false);
    } catch (error) {
      await setLoading(false);
      handleSnackbarOpen('error', t('messages:no_data_found'));
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setLoading(false);
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const getDepartmentByInstituteId = async (id) => {
    try {
      await setLoading(true);
      await setSelectedInstitute(id);
      const getDepartment = await getInstituteByTypeAndInstitute('dept', id);
      const mapDept = getDepartment.map((v) => {
        return { label: v.Name, value: v.Id, ...v };
      });
      if (type === 1) {
        mapDept.push({ label: t('labels:All'), value: 'All', Id: 'All' });
      }
      await setDepartments(mapDept);
      await setLoading(false);
    } catch (error) {
      await setLoading(false);
      handleSnackbarOpen('error', t('messages:no_data_found'));
    }
  };
  const selectInstitute = (e) => {
    const instituteId = e.target.value;
    setSelectedInstitute(instituteId);
    if (instituteId !== 'All') {
      getDepartmentByInstituteId(instituteId);
    }
  };
  const selectDepartment = (e) => {
    const deptId = e.target.value;
    setSelectedDepartments(deptId);
    if (deptId !== 'All') {
      getProgramByDeptId(deptId);
    }
  };
  const selectTypeHandle = (contactTypes) => {
    const payloadDetails = {
      institutes: [selectedInstitute],
      departments: [selectedDepartments],
      classIds: classIds.length > 0 ? classIds : ['All'],
      types: contactTypes,
    };
    handleGradeWiseDetails(payloadDetails);
    if (handleAllOption) {
      handleAllOption({
        institute,
        departments,
        grades,
        contactType,
      });
    }
  };

  const selectGradeDetails = async (event, newValue) => {
    await setClassIds([]);
    const classId = newValue.map((v) => {
      return v.Id;
    });
    await setSelectedClassIds(classId);
    await setClassIds(classId);
  };

  return (
    <div>
      {typeValue == 'institute' && institute.length > 0 && (
        <Box mt={2} mb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4} md={4}>
              <KenSelect
                options={institute}
                onChange={selectInstitute}
                label={t('labels:select_institute')}
                required
              />
            </Grid>
          </Grid>
        </Box>
      )}

      {typeValue == 'institute' &&
        selectedInstitute != 'All' &&
        departments.length > 0 && (
          <Box mt={2} mb={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4}>
                <KenSelect
                  options={departments}
                  onChange={selectDepartment}
                  label={t('labels:select_department')}
                  required={true}
                />
              </Grid>
            </Grid>
          </Box>
        )}

      {typeValue == 'institute' &&
        selectedDepartments != 'All' &&
        grades.length > 0 && (
          <Box mt={2} mb={2}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4}>
                <KenAutoComplete
                  options={grades}
                  label={t('labels:select_grade')}
                  variant="outlined"
                  onChange={selectGradeDetails}
                  placeholder={t('labels:select_grade')}
                  required
                />
              </Grid>
            </Grid>
          </Box>
        )}

      {typeValue == 'institute' && (grades.length > 0 || type === 1) && (
        <Box mt={2} mb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4} md={4}>
              <KenAutoComplete
                options={contactType}
                label={t('labels:select_contact_type')}
                variant="outlined"
                onChange={async (event, newValue) => {
                  const contactType = newValue.map((v) => {
                    return v.value;
                  });
                  selectTypeHandle(contactType);
                }}
                placeholder={t('labels:select_contact_type')}
                required
              />
            </Grid>
          </Grid>
        </Box>
      )}

      {loading && <KenLoader />}

      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />
    </div>
  );
};

export default SmsAndMailSelection;
